import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute({ requiredPermission }) {
  const { auth, hasPermission } = useAuth();

  if (!auth.token) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
